<iframe [src]="crossLogoutUrl" frameborder="0"></iframe>
